/**
 * QuantiyButton Component
 * expects a wrapper element
 * requires element to have three defined data elements
 * for increase and decrease buttons and the quantitiy input
 * Dispatches an event for use in cart
 **/
import eventBus from "../services/event-bus";
import elementExists from "../utils/element-exists";

const QuantityComponent = function (containerElement) {
  const defaults = { minValue: 0, maxValue: 1000 };
  let _this = {};
  let timeout = false;
  let data = containerElement.dataSet;
  let quantityDec = containerElement.querySelector('[data-quantity-dec]');
  let quantityInc = containerElement.querySelector('[data-quantity-inc]');
  let quantityInput = containerElement.querySelector('[data-quantity-input]');

  data = Object.assign(defaults, data);




  const removeListeners = () => {
    // remove the listeners first
    // these may be added dynamically to the page
    quantityDec.removeEventListener('click', () => { });
    quantityInc.removeEventListener('click', () => { });
    quantityInput.removeEventListener('keyup', () => { });
  }


  const init = function () {
    removeListeners();
    quantityDec.addEventListener('click', function () {
      updateQuantity('dec')
    });

    quantityInc.addEventListener('click', function () {
      updateQuantity('inc')
    });

    quantityInput.addEventListener('keyup', function () {
      let val = parseInt(quantityInput.value);

      timeout = setTimeout(function () {
        eventBus.dispatch(eventBus.types.QuantityUpdated, {
          target: containerElement,
          value: val
        })
      }, 250)
    })
  }


  const updateQuantity = function (dir) {
    clearTimeout(timeout)

    let val = parseInt(quantityInput.value);
    if (dir == 'dec') {
      if (val == data.minValue) return;
      val -= 1;
    }
    if (dir == 'inc') {
      if (val == data.maxValue) return;
      val += 1;
    }

    quantityInput.value = val
    timeout = setTimeout(function () {
      eventBus.dispatch(eventBus.types.QuantityUpdated, {
        target: containerElement,
        value: val
      })
    }, 250)
  }

  // call InitQuantityInput
  if (elementExists(quantityDec) && elementExists(quantityInc) && elementExists(quantityInput)) {
    init();
  }

}

export default QuantityComponent;
